import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CampaignDatatableModule } from '../../../shared/components/campaign-datatable/campaign-datatable.module';
import { TranslateModule } from '@ngx-translate/core';
import { ReportsRollupWorkflowModule } from './reports-rollup-workflow.module';
import { ReportsRollupMainComponent } from './reports-rollup-main.component';

@NgModule({
  declarations: [ReportsRollupMainComponent],
  imports: [
    CommonModule,
    FormsModule,
    CampaignDatatableModule,
    TranslateModule,
    ReportsRollupWorkflowModule
  ],
  exports: [ReportsRollupMainComponent]
})
export class ReportsRollupMainModule {}